import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const mediaWidgetFeatureFlag: FeatureFlagType = {
  name: 'media_widget',
  fallback: false,
};

export const useIsMediaWidgetEnabled = () => {
  const [, isMediaWidgetEnabled] = useFeatureFlag(mediaWidgetFeatureFlag);

  return isMediaWidgetEnabled;
};
